import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (
    curPageId: string,
    formConfig: FormConfig,
    formValues: FormValues
): Promise<string | undefined> => {
    switch (curPageId) {
        case 'godt-at-vide':
            return 'hvornaar-skete-skaden';

        case 'hvornaar-skete-skaden':
            return 'adresser';

        case 'adresser':
            return 'hvordan';

        case 'hvordan':
            return 'reparation';

        case 'reparation':
            return 'andet';

        case 'andet':
            return 'dokumentation';

        case 'dokumentation':
            return 'om-dig';

        case 'om-dig':
            return 'andet-selskab';

        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                return 'hvilket-selskab';
            }

            return 'resume';

        case 'hvilket-selskab':
            return 'resume';

        case 'resume':
            return undefined;

        default:
            throw new Error('Unknown page: ' + curPageId);
    }
};
